import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { NotificationModel } from '../../../shared/models/notification.model';
import { HttpClient } from '@angular/common/http';
import { mapResponseWithData } from '@sc/pas-common';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var NotificationService = /** @class */ (function () {
    function NotificationService(httpClient) {
        this.httpClient = httpClient;
        this.unseenNotificationsCount = 0;
    }
    NotificationService.prototype.getUnseenNotificationsCount = function () {
        var _this = this;
        var url = environment.server.api.notification + '/portalpas/notifications/count/unseen';
        this.httpClient.get(url).pipe(map(mapResponseWithData)).subscribe(function (unseenCount) {
            _this.unseenNotificationsCount = unseenCount;
        }, function (error) {
            _this.unseenNotificationsCount = 0;
            console.error(error);
        });
    };
    NotificationService.prototype.getNotifications = function (pageNumber) {
        //Cuando llamemos al servicio siempre que el page number sea 1 guardar el primer id en firstNotificationId;
        if (pageNumber === void 0) { pageNumber = 1; }
        return this.httpClient.get(environment.server.api.notification + '/portalpas/notifications').pipe(map(function (response) {
            response.map(function (item) {
                item.data = JSON.parse(item.data);
                return new NotificationModel(item);
            });
            return response;
        }));
    };
    NotificationService.prototype.getNotificationsByStatus = function (read) {
        return this.httpClient.get(environment.server.api.notification + "/portalpas/notifications/list/" + read).pipe(map(function (response) {
            return response.map(function (item) {
                item.data = JSON.parse(item.data);
                return new NotificationModel(item);
            });
        }));
    };
    NotificationService.prototype.setStatusNotifications = function (notificationId, read) {
        return this.httpClient.get(environment.server.api.notification + "/portalpas/notifications/mark/" + notificationId + "/" + read);
    };
    NotificationService.prototype.getNotificationById = function (notificationId) {
        return this.httpClient.get(environment.server.api.notification + "/portalpas/notification/" + notificationId)
            .pipe(map(function (response) {
            var item = new NotificationModel(response);
            item.data = JSON.parse(response.data);
            return item;
        }));
    };
    NotificationService.prototype.getNotificationTitleCard = function (notification) {
        var title;
        switch (notification.notificationTypeId) {
            case 'APROBACION_UW':
                title = 'Aprobación de fuera de pauta';
                if (notification.jobSubType === 'PolicyChange') {
                    title += ' en endoso';
                }
                break;
            case 'CANCELACION_POLIZA':
                title = 'Cancelación de póliza';
                break;
            case 'RECHAZO_UW':
                title = 'Rechazo de fuera de pauta';
                break;
            case 'RECHAZO_PAGO':
                title = 'Nuevas Respuestas del Banco';
                break;
        }
        return title;
    };
    NotificationService.prototype.getNotificationTypeAction = function (notification) {
        var actions;
        switch (notification.notificationTypeId) {
            case 'APROBACION_UW':
                if (notification.jobSubType === 'PolicyChange') {
                    actions = notification.notificationType.notificationTypeActions.filter(function (act) { return act.displayText === 'Más información'; });
                }
                else {
                    actions = notification.notificationType.notificationTypeActions.filter(function (act) { return act.displayText === 'Continuar con la emisión'; });
                }
                break;
            case 'CANCELACION_POLIZA':
                actions = notification.notificationType.notificationTypeActions;
                break;
            case 'RECHAZO_UW':
                actions = notification.notificationType.notificationTypeActions;
                break;
            case 'RECHAZO_PAGO':
                actions = notification.notificationType.notificationTypeActions;
                break;
        }
        return actions;
    };
    NotificationService.prototype.putMarkSeenNotifications = function (id) {
        var payload = {
            notificationId: id
        };
        return this.httpClient.post(environment.server.api.notification + '/portalpas/notifications/mark/seen', payload);
    };
    NotificationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.ɵɵinject(i1.HttpClient)); }, token: NotificationService, providedIn: "root" });
    return NotificationService;
}());
export { NotificationService };
